// extracted by mini-css-extract-plugin
export var blue = "_34-f";
export var brand = "_34-b";
export var darkGrey = "_34-e";
export var disabled = "_34-4";
export var disabledSubtle = "_34-5";
export var error = "_34-6";
export var green = "_34-g";
export var grey = "_34-d";
export var icon = "_34-0";
export var inherit = "_34-a";
export var lightGrey = "_34-c";
export var orange = "_34-i";
export var pink = "_34-k";
export var primary = "_34-1";
export var purple = "_34-l";
export var red = "_34-j";
export var secondary = "_34-2";
export var success = "_34-9";
export var tertiary = "_34-3";
export var warning = "_34-7";
export var warningSecondary = "_34-8";
export var white = "_34-m";
export var yellow = "_34-h";